import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { V2AuthService } from '../services/v2auth.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-v2token-validation',
  templateUrl: './v2token-validation.component.html',
  styleUrls: ['./v2token-validation.component.scss']
})
export class V2TokenValidationComponent implements OnInit {
  errorMessage: string | null = null;
  successMessage: string | null = null;
  tokenDto: any = null; 

  constructor(
    private route: ActivatedRoute, 
    private router: Router,
    private authService: V2AuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      if (token) {
        this.authService.redeemLoginToken(token).subscribe({
          next: (response) => {
            localStorage.setItem('auth_token', response.token); 
            this.tokenDto = response;
            console.log('Token DTO:', this.tokenDto);
            this.successMessage = "Token validated successfully. You can now proceed to the application.";
            this.errorMessage = null;
          },
          error: (error: HttpErrorResponse) => {
            console.error('Error redeeming token:', error);

            if (error.status === 400) {
              switch (error.error) {
                case 'Token expired.':
                  this.errorMessage = "Your token has expired. Please request a new login link.";
                  break;
                case 'Token is required.':
                  this.errorMessage = "No token provided. Please check the link and try again.";
                  break;
                case 'Invalid user id in token.':
                  this.errorMessage = "Invalid user information in the token. Please request a new login link.";
                  break;
                default:
                  this.errorMessage = "An error occurred while redeeming the token. Please try again.";
              }
            } else if (error.status === 404) {
              this.errorMessage = "User not found. Please contact support.";
            } else {
              this.errorMessage = "An unexpected error occurred. Please try again.";
            }

            this.successMessage = null;
          }
        });
      } else {
        console.error('No token found in URL.');
        this.errorMessage = "No token was found in the URL. Please check the link and try again.";
      }
    });
  }
}